import { render, staticRenderFns } from "./language_modal.vue?vue&type=template&id=be57e49e&"
import script from "./language_modal.vue?vue&type=script&lang=js&"
export * from "./language_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports